// src/pages/About.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../App.css';

const About = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div
      className={`container ${isRTL ? 'arabic-font' : ''}`}
      style={{ direction: isRTL ? 'rtl' : 'ltr', padding: '2rem 1rem' }}
    >
      {/* Mission & Vision Card */}
      <section className="about-card">
        <h2>{t('missionVisionTitle')}</h2>

        {/* Mission */}
        <h3 style={{ marginTop: '1rem' }}>{t('missionHeading')}</h3>
        <p>{t('missionIntro')}</p>
        <ul>
          <li>{t('missionPoint1')}</li>
          <li>{t('missionPoint2')}</li>
          <li>{t('missionPoint3')}</li>
          <li>{t('missionPoint4')}</li>
          <li>{t('missionPoint5')}</li>
        </ul>
        <p><em>{t('missionClosing')}</em></p>

        {/* Vision */}
        <h3 style={{ marginTop: '2rem' }}>{t('visionHeading')}</h3>
        <p>{t('visionIntro')}</p>
        <ul>
          <li>{t('visionPoint1')}</li>
          <li>{t('visionPoint2')}</li>
          <li>{t('visionPoint3')}</li>
          <li>{t('visionPoint4')}</li>
          <li>{t('visionPoint5')}</li>
        </ul>
        <p>{t('visionSDGIntro')}</p>
        <ul>
          <li>{t('sdg4')}</li>
          <li>{t('sdg10')}</li>
        </ul>
        <p><em>{t('visionClosing')}</em></p>
      </section>

      {/* About Movement Card */}
      <section className="about-card">
        <h2 className="about-title">{t('aboutTitle')}</h2>
        <p>{t('aboutIntro')}</p>

        {/* What We Do */}
        <h3 style={{ marginTop: '1.5rem' }}>{t('aboutWorkTitle')}</h3>
        <ul>
          <li>{t('aboutBooks')}</li>
          <li>{t('aboutTraining')}</li>
          <li>{t('aboutCampaigns')}</li>
          <li>{t('aboutPartnerships')}</li>
          <li>{t('aboutEngagement')}</li>
        </ul>

        {/* Partnerships */}
        <h3 style={{ marginTop: '1.5rem' }}>{t('aboutPartnersTitle')}</h3>
        <p>{t('aboutPartners')}</p>

        {/* Join the Journey */}
        <h3 style={{ marginTop: '1.5rem' }}>{t('aboutJoinTitle')}</h3>
        <ul>
          <li>✅ {t('aboutOffer1')}</li>
          <li>✅ {t('aboutOffer2')}</li>
          <li>✅ {t('aboutOffer3')}</li>
          <li>✅ {t('aboutOffer4')}</li>
        </ul>
      </section>
    </div>
  );
};

export default About;
